import { createContext, useContext } from "react";
import { Actions } from "./types";
import { Lang } from "services/guest/reference/types";

export type LangContextType = [Lang[] | undefined, (action: Actions) => void];

export const LangContext = createContext<LangContextType | null>(null);

// Narrower alternative to useStore() for consumers that only need `auth`
// + dispatch — re-renders only when the auth slice changes, not on every
// settings/langs/references update. Backed by the same StoreProvider reducer.
export const useLangs = (): LangContextType => {
  const context = useContext(LangContext);
  if (!context) {
    throw new Error("useAuth must be used within StoreProvider");
  }
  return context;
};
